var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllRegisterfound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 380,
    height: 115.797,
    viewBox: "0 0 380 115.797",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ill_registerfound",
    transform: "translate(190 57.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ill_registerfound-2",
    "data-name": "ill_registerfound",
    transform: "translate(-190 -57.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_123806",
    "data-name": "Path 123806",
    d: "M42.488,53.189A126.666,126.666,0,0,0,78.664,21.231C85.213,12.884,92.6,8.02,101.223,13.162h0A31.071,31.071,0,0,0,130.6,14.7L133,13.58a90.073,90.073,0,0,1,78.065.215l16.365,7.727a30.78,30.78,0,0,0,20.811,2.153,30.78,30.78,0,0,1,17.619,1.013h0a41.141,41.141,0,0,0,34.58-3.534c14.415-8.322,24.877-12.793,42.611-1.267h0c16.34,10.6,32.325,19.583,35.695,42.167,3.116,20.875-9.855,33.225,4.129,46.132l13.034,11.134H18.51C45.541,85.806,28.289,61.359,42.488,53.189Z",
    transform: "translate(-17.243 -4.791)",
    fill: "#e0f0d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123807",
    "data-name": "Path 123807",
    d: "M187.53,61.667V51.762a9.652,9.652,0,0,1,9.639-9.652h12.059a9.652,9.652,0,0,1,9.639,9.652V66.227h-22.5a21.229,21.229,0,0,0-8.841-4.56Z",
    transform: "translate(27.829 5.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123808",
    "data-name": "Path 123808",
    d: "M202.393,40.527a11.843,11.843,0,1,1,11.843-11.843,11.843,11.843,0,0,1-11.843,11.843Z",
    transform: "translate(28.634 -1.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123809",
    "data-name": "Path 123809",
    d: "M197.169,42.11a9.652,9.652,0,0,0-9.639,9.652v9.905a21.229,21.229,0,0,1,8.867,4.56h1.482A43.675,43.675,0,0,0,207.1,42.161Z",
    transform: "translate(27.829 5.161)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123810",
    "data-name": "Path 123810",
    d: "M196.676,18.06a11.767,11.767,0,0,0,9.31,21.533,43.6,43.6,0,0,0-9.31-21.533Z",
    transform: "translate(28.6 -1.253)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123811",
    "data-name": "Path 123811",
    d: "M156.067,61.667V51.762a9.652,9.652,0,0,0-9.639-9.652H134.369a9.652,9.652,0,0,0-9.639,9.652V66.227h22.5a21.229,21.229,0,0,1,8.841-4.56Z",
    transform: "translate(11.082 5.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123812",
    "data-name": "Path 123812",
    d: "M127.75,28.683a11.843,11.843,0,1,1,11.843,11.843A11.843,11.843,0,0,1,127.75,28.683Z",
    transform: "translate(11.887 -1.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123813",
    "data-name": "Path 123813",
    d: "M121.325,66.227V51.762a9.652,9.652,0,0,0-9.639-9.652H99.627A9.652,9.652,0,0,0,90,51.762V66.227Z",
    transform: "translate(1.821 5.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123814",
    "data-name": "Path 123814",
    d: "M93,28.683a11.843,11.843,0,1,1,11.843,11.843A11.843,11.843,0,0,1,93,28.683Z",
    transform: "translate(2.621 -1.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123815",
    "data-name": "Path 123815",
    d: "M143.943,42.11H134.05a43.574,43.574,0,0,0,9.209,24.067h1.482a21.23,21.23,0,0,1,8.867-4.56V51.762a9.652,9.652,0,0,0-9.665-9.652Z",
    transform: "translate(13.567 5.161)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123816",
    "data-name": "Path 123816",
    d: "M143.6,18.06a43.6,43.6,0,0,0-9.31,21.533A11.78,11.78,0,0,0,143.6,18.06Z",
    transform: "translate(13.631 -1.253)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123817",
    "data-name": "Path 123817",
    d: "M139.86,42.06a13.11,13.11,0,1,1,13.11-13.11A13.11,13.11,0,0,1,139.86,42.06Zm0-23.687A10.577,10.577,0,1,0,150.437,28.95,10.577,10.577,0,0,0,139.86,18.373Z",
    transform: "translate(11.621 -1.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123818",
    "data-name": "Path 123818",
    d: "M144.339,67.761H125a1.267,1.267,0,0,1-1.267-1.267V52.029A10.931,10.931,0,0,1,134.636,41.11h12.059a1.267,1.267,0,0,1,0,2.533H134.636a8.4,8.4,0,0,0-8.373,8.385v13.2h18.075a1.267,1.267,0,0,1,0,2.533Z",
    transform: "translate(10.815 4.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123819",
    "data-name": "Path 123819",
    d: "M202.66,42.06a13.11,13.11,0,1,1,13.11-13.11,13.11,13.11,0,0,1-13.11,13.11Zm0-23.687A10.577,10.577,0,1,0,213.237,28.95,10.577,10.577,0,0,0,202.66,18.373Z",
    transform: "translate(28.367 -1.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123820",
    "data-name": "Path 123820",
    d: "M217.1,67.761H197.826a1.267,1.267,0,0,1,0-2.533h18.012v-13.2a8.385,8.385,0,0,0-8.373-8.385H195.407a1.267,1.267,0,0,1,0-2.533h12.059a10.931,10.931,0,0,1,10.906,10.919V66.494A1.267,1.267,0,0,1,217.1,67.761Z",
    transform: "translate(29.591 4.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123821",
    "data-name": "Path 123821",
    d: "M121.591,67.761H90.267A1.267,1.267,0,0,1,89,66.494V52.029A10.931,10.931,0,0,1,99.906,41.11h12.059a10.931,10.931,0,0,1,10.906,10.919V66.494a1.267,1.267,0,0,1-1.279,1.267ZM91.533,65.227h28.8v-13.2a8.4,8.4,0,0,0-8.373-8.385H99.893a8.385,8.385,0,0,0-8.36,8.385Z",
    transform: "translate(1.554 4.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123822",
    "data-name": "Path 123822",
    d: "M105.12,42.06a13.11,13.11,0,1,1,13.11-13.11,13.11,13.11,0,0,1-13.11,13.11Zm0-23.687A10.577,10.577,0,1,0,115.7,28.95,10.577,10.577,0,0,0,105.12,18.373Z",
    transform: "translate(2.357 -1.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123823",
    "data-name": "Path 123823",
    d: "M86.6,66.227V51.762a9.652,9.652,0,0,0-9.639-9.652H64.889a9.652,9.652,0,0,0-9.639,9.652V66.227Z",
    transform: "translate(-7.446 5.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123824",
    "data-name": "Path 123824",
    d: "M58.27,28.683A11.843,11.843,0,1,1,70.113,40.527,11.843,11.843,0,0,1,58.27,28.683Z",
    transform: "translate(-6.641 -1.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123825",
    "data-name": "Path 123825",
    d: "M86.867,67.761H55.517a1.267,1.267,0,0,1-1.267-1.267V52.029A10.931,10.931,0,0,1,65.156,41.11H77.215A10.931,10.931,0,0,1,88.133,52.029V66.494A1.267,1.267,0,0,1,86.867,67.761ZM56.8,65.227H85.6v-13.2a8.4,8.4,0,0,0-8.373-8.385H65.156a8.385,8.385,0,0,0-8.373,8.385Z",
    transform: "translate(-7.713 4.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123826",
    "data-name": "Path 123826",
    d: "M70.372,42.06A13.11,13.11,0,1,1,83.52,28.95,13.11,13.11,0,0,1,70.372,42.06Zm0-23.687a10.577,10.577,0,1,0,7.5,3.084A10.577,10.577,0,0,0,70.372,18.373Z",
    transform: "translate(-6.899 -1.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123827",
    "data-name": "Path 123827",
    d: "M51.847,66.227V51.762a9.652,9.652,0,0,0-9.639-9.652H30.149a9.652,9.652,0,0,0-9.639,9.652V66.227Z",
    transform: "translate(-16.71 5.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123828",
    "data-name": "Path 123828",
    d: "M23.53,28.683A11.843,11.843,0,1,1,35.373,40.527,11.843,11.843,0,0,1,23.53,28.683Z",
    transform: "translate(-15.905 -1.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123829",
    "data-name": "Path 123829",
    d: "M52.114,67.761H20.777a1.267,1.267,0,0,1-1.267-1.267V52.029A10.931,10.931,0,0,1,30.416,41.11H42.475A10.931,10.931,0,0,1,53.381,52.029V66.494A1.267,1.267,0,0,1,52.114,67.761ZM22.043,65.227h28.8v-13.2a8.4,8.4,0,0,0-8.373-8.385H30.416a8.385,8.385,0,0,0-8.373,8.385Z",
    transform: "translate(-16.977 4.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123830",
    "data-name": "Path 123830",
    d: "M35.64,42.06A13.11,13.11,0,1,1,48.75,28.95,13.11,13.11,0,0,1,35.64,42.06Zm0-23.687A10.577,10.577,0,1,0,46.217,28.95,10.577,10.577,0,0,0,35.64,18.373Z",
    transform: "translate(-16.171 -1.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123831",
    "data-name": "Path 123831",
    d: "M323.087,66.227V51.762a9.639,9.639,0,0,0-9.639-9.652H301.4a9.652,9.652,0,0,0-9.652,9.652V66.227Z",
    transform: "translate(55.621 5.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123832",
    "data-name": "Path 123832",
    d: "M294.77,28.683a11.843,11.843,0,1,1,11.856,11.843A11.843,11.843,0,0,1,294.77,28.683Z",
    transform: "translate(56.426 -1.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123833",
    "data-name": "Path 123833",
    d: "M323.354,67.761H292.017a1.267,1.267,0,0,1-1.267-1.267V52.029A10.931,10.931,0,0,1,301.669,41.11h12.046a10.931,10.931,0,0,1,10.906,10.919V66.494A1.267,1.267,0,0,1,323.354,67.761Zm-30.071-2.533h28.8v-13.2a8.385,8.385,0,0,0-8.373-8.385H301.669a8.4,8.4,0,0,0-8.385,8.385Z",
    transform: "translate(55.354 4.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123834",
    "data-name": "Path 123834",
    d: "M306.893,42.06a13.11,13.11,0,1,1,13.1-13.11,13.11,13.11,0,0,1-13.1,13.11Zm0-23.687A10.577,10.577,0,1,0,317.457,28.95,10.577,10.577,0,0,0,306.893,18.373Z",
    transform: "translate(56.159 -1.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123835",
    "data-name": "Path 123835",
    d: "M288.35,66.227V51.762a9.639,9.639,0,0,0-9.639-9.652H266.665A9.652,9.652,0,0,0,257,51.762V66.227Z",
    transform: "translate(46.354 5.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123836",
    "data-name": "Path 123836",
    d: "M260,28.683a11.843,11.843,0,1,1,11.843,11.843A11.843,11.843,0,0,1,260,28.683Z",
    transform: "translate(47.154 -1.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123837",
    "data-name": "Path 123837",
    d: "M288.617,67.761h-31.35A1.267,1.267,0,0,1,256,66.494V52.029A10.931,10.931,0,0,1,266.906,41.11h12.059a10.931,10.931,0,0,1,10.906,10.919V66.494a1.267,1.267,0,0,1-1.254,1.267Zm-30.071-2.533h28.8v-13.2a8.385,8.385,0,0,0-8.373-8.385H266.919a8.4,8.4,0,0,0-8.385,8.385Z",
    transform: "translate(46.087 4.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123838",
    "data-name": "Path 123838",
    d: "M272.14,42.06a13.11,13.11,0,1,1,13.11-13.11,13.11,13.11,0,0,1-13.11,13.11Zm0-23.687A10.577,10.577,0,1,0,282.717,28.95,10.577,10.577,0,0,0,272.14,18.373Z",
    transform: "translate(46.895 -1.845)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123839",
    "data-name": "Path 123839",
    d: "M253.6,66.227V51.762a9.652,9.652,0,0,0-9.639-9.652H231.9a9.652,9.652,0,0,0-9.639,9.652V66.227Z",
    transform: "translate(37.09 5.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123840",
    "data-name": "Path 123840",
    d: "M225.29,28.683a11.843,11.843,0,1,1,11.843,11.843A11.843,11.843,0,0,1,225.29,28.683Z",
    transform: "translate(37.898 -1.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123841",
    "data-name": "Path 123841",
    d: "M253.861,67.761H222.537a1.267,1.267,0,0,1-1.267-1.267V52.029A10.931,10.931,0,0,1,232.176,41.11h12.059a10.931,10.931,0,0,1,10.893,10.919V66.494A1.267,1.267,0,0,1,253.861,67.761Zm-30.071-2.533h28.8v-13.2a8.385,8.385,0,0,0-8.373-8.385H232.163a8.4,8.4,0,0,0-8.373,8.385Z",
    transform: "translate(36.826 4.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123842",
    "data-name": "Path 123842",
    d: "M237.4,42.06A13.11,13.11,0,1,1,250.52,28.95,13.11,13.11,0,0,1,237.4,42.06Zm0-23.687A10.577,10.577,0,1,0,247.987,28.95,10.577,10.577,0,0,0,237.4,18.373Z",
    transform: "translate(37.634 -1.845)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10636",
    "data-name": "Ellipse 10636",
    cx: 20.267,
    cy: 20.267,
    r: 20.267,
    transform: "translate(170.987 23.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123843",
    "data-name": "Path 123843",
    d: "M184.449,26.93A20.267,20.267,0,0,1,156,55.4,20.267,20.267,0,1,0,184.475,26.93Z",
    transform: "translate(19.421 1.113)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123844",
    "data-name": "Path 123844",
    d: "M160.019,42.53a.709.709,0,0,0-.684.887,12,12,0,0,0,23.231,0,.709.709,0,0,0-.684-.887Z",
    transform: "translate(20.304 5.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123845",
    "data-name": "Path 123845",
    d: "M173.3,23.983A20.267,20.267,0,1,1,153.033,44.25,20.267,20.267,0,0,1,173.3,23.983m0-2.533a22.8,22.8,0,1,0,22.8,22.8,22.8,22.8,0,0,0-22.8-22.8Z",
    transform: "translate(17.954 -0.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123846",
    "data-name": "Path 123846",
    d: "M164.4,39.062a1.9,1.9,0,0,1-1.9-1.9V34.73a1.9,1.9,0,1,1,3.8,0v2.432A1.9,1.9,0,0,1,164.4,39.062Z",
    transform: "translate(21.154 2.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123847",
    "data-name": "Path 123847",
    d: "M173.4,39.062a1.9,1.9,0,0,1-1.9-1.9V34.73a1.9,1.9,0,1,1,3.8,0v2.432A1.9,1.9,0,0,1,173.4,39.062Z",
    transform: "translate(23.554 2.686)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123848",
    "data-name": "Path 123848",
    d: "M140.45,104.373v-22.2A21.331,21.331,0,0,1,161.768,60.85H163.3a28.6,28.6,0,0,0,25.333,0h1.533a21.331,21.331,0,0,1,21.318,21.318v22.2Z",
    transform: "translate(15.274 10.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123849",
    "data-name": "Path 123849",
    d: "M192.971,99.007H183.23V80.97Z",
    transform: "translate(26.682 15.523)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123850",
    "data-name": "Path 123850",
    d: "M146.16,99.007H155.9V80.97Z",
    transform: "translate(16.797 15.523)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123851",
    "data-name": "Path 123851",
    d: "M183.5,100.533a1.267,1.267,0,0,1-1.267-1.267v-18a1.267,1.267,0,1,1,2.533,0v18A1.267,1.267,0,0,1,183.5,100.533Z",
    transform: "translate(26.415 15.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123852",
    "data-name": "Path 123852",
    d: "M153.957,100.533a1.267,1.267,0,0,1-1.267-1.267v-18a1.267,1.267,0,1,1,2.533,0v18A1.267,1.267,0,0,1,153.957,100.533Z",
    transform: "translate(18.538 15.265)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123853",
    "data-name": "Path 123853",
    d: "M211.777,105.906a1.267,1.267,0,0,1-1.267-1.267v-22.2a20.077,20.077,0,0,0-20.051-20.051,5.662,5.662,0,0,0-2.331.494,29.944,29.944,0,0,1-23.75,0,5.662,5.662,0,0,0-2.242-.494,20.089,20.089,0,0,0-20.153,20.051v22.2a1.267,1.267,0,1,1-2.533,0v-22.2A22.61,22.61,0,0,1,162.035,59.85a8.145,8.145,0,0,1,3.331.7,27.36,27.36,0,0,0,21.761,0,8.018,8.018,0,0,1,3.217-.7,22.635,22.635,0,0,1,22.7,22.585v22.2A1.267,1.267,0,0,1,211.777,105.906Z",
    transform: "translate(15.007 9.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123854",
    "data-name": "Path 123854",
    d: "M158.653,80.926a1.267,1.267,0,0,1,0-1.837l1.811-1.824a1.267,1.267,0,0,1,1.837,0l5.662,5.675L180.11,70.793a1.267,1.267,0,0,1,1.837,0l1.837,1.824a1.267,1.267,0,0,1,0,1.837l-14.871,14.9a1.267,1.267,0,0,1-1.837,0Z",
    transform: "translate(20.023 12.704)",
    fill: "#82c45b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123855",
    "data-name": "Path 123855",
    d: "M396.18,96.743H18.777a1.267,1.267,0,0,1,0-2.533H396.243a1.267,1.267,0,0,1,0,2.533Z",
    transform: "translate(-17.51 19.054)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllRegisterfound);
export default __webpack_public_path__ + "static/media/ill_registerfound.3398581b0be1239e1b36d2b2bed80298.svg";
export { ForwardRef as ReactComponent };